import { render, staticRenderFns } from "./BulkRoomCreator.vue?vue&type=template&id=a0be196a&scoped=true&"
import script from "./BulkRoomCreator.vue?vue&type=script&lang=js&"
export * from "./BulkRoomCreator.vue?vue&type=script&lang=js&"
import style0 from "./BulkRoomCreator.vue?vue&type=style&index=0&id=a0be196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0be196a",
  null
  
)

export default component.exports